import "../css/footer.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function Footer() {
  const path = useLocation().pathname;
  const currentTheme = useSelector((state) => state.theme.current);

  return (
    <div className="footer" style={{ background: `${currentTheme}` }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="footer-contact">
              <h2>Contact Us</h2>
              <a href="" target="_blank" rel="noopener noreferrer">
                <p className="pb-2">
                  <i className="fa fa-map-marker-alt"></i>Dongri, Mumbai, India
                </p>
              </a>
              <a href="tel:+91-7400231537">
                <p className="pb-2">
                  <i className="fa fa-phone"></i>+91-7400231537
                </p>
              </a>
              <a href="tel:+91-7738805577">
                <p className="pb-2">
                  <i className="fa fa-phone"></i>+91-7738805577
                </p>
              </a>
              <a href="mailto:alqaimwelfareinfo@gmail.com">
                <p className="pb-2">
                  <i className="fa fa-envelope"></i>alqaimwelfareinfo@gmail.com
                </p>
              </a>
              <div className="footer-social">
                {/* <a className="btn btn-custom" href="https://twitter.com"><i className="fab fa-x-twitter"></i></a> */}
                <a
                  className="btn btn-custom"
                  href="https://www.facebook.com/profile.php?id=61567726026527&mibextid=ZbWKwL"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  className="btn btn-custom"
                  href="https://www.instagram.com/al.qaim_welfare/profilecard/?igsh=OXpjZ3Y3bTExbnE3"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                {/* <a className="btn btn-custom" href="https://www.youtube.com"><i className="fab fa-youtube"></i></a> */}
                <a
                  className="btn btn-custom"
                  href="https://www.threads.net/@al.qaim_welfare?invite=0"
                >
                  <i className="fab fa-threads"></i>
                </a>
                <a
                  className="btn btn-custom"
                  href="https://www.youtube.com/@AlQaimWelfareFoundation?target=_blank"
                >
                  <i className="fab fa-youtube"></i>
                </a>
                <a
                  className="btn btn-custom"
                  href="https://whatsapp.com/channel/0029Vb8U49IG3R3b3NaFGv3c?target=_blank"
                >
                  <i className="fab fa-whatsapp"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="footer-link">
              <h2>Popular Links</h2>
              {/* <a href="/KnowMore">About Us</a> */}
              <Link
                to="/knowMore"
                className={`nav-item nav-link ${
                  path === "/about" ? "active" : ""
                }`}
              >
                About Us
              </Link>
              <Link
                to="/contact"
                className={`nav-item nav-link ${
                  path === "/contact" ? "active" : ""
                }`}
              >
                Contact Us
              </Link>
              <Link
                to="/event"
                className={`nav-item nav-link ${
                  path === "/event" ? "active" : ""
                }`}
              >
                Sermons
              </Link>
              <Link
                to="/donate"
                className="nav-item nav-link"
                style={{ color: "green" }}
              >
                Donate
              </Link>
              <Link to="/needhelp" className="nav-item nav-link">
                Need Help
              </Link>
              {/* <a href="/event">Upcoming Events</a>
                            <a href="#">Latest Blog</a> */}
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="footer-link">
              <h2>Useful Links</h2>
              {/* <a href="/TermsAndPrivacyPolicy">Terms of use &  Privacy Policy</a> */}
              <Link
                to="/TermsAndPrivacyPolicy"
                className={`nav-item nav-link ${
                  path === "/TermsAndPrivacyPolicy" ? "active" : ""
                }`}
              >
                Terms of use & Privacy Policy
              </Link>
              {/* <a href="/TermsAndPrivacyPolicy">Privacy policy</a> */}
              {/* <a href="#">Cookies</a> */}
              <Link
                to="/contact"
                className={`nav-item nav-link ${
                  path === "/contact" ? "active" : ""
                }`}
              >
                Help
              </Link>
              <Link
                to="/wam"
                className={`nav-item nav-link ${
                  path === "/wam" ? "active" : ""
                }`}
              >
                Want to Become AQWF Member?
              </Link>
              <Link
                to="/member-agreement"
                className={`nav-item nav-link ${
                  path === "/member-agreement" ? "active" : ""
                }`}
              >
                Member Agreement Form
              </Link>
              <Link
                to="/volunteer-agreement"
                className={`nav-item nav-link ${
                  path === "/volunteer-agreement" ? "active" : ""
                }`}
              >
                Volunteer Agreement Form
              </Link>
              <Link
                to="/sadqa-box"
                className={`nav-item nav-link ${
                  path === "/sadqa-box" ? "active" : ""
                }`}
              >
                Sadqa Box Form
              </Link>
              {/* <a href="/contact">Help</a> */}
              {/* <a href="#">FQAs</a> */}
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            {/* <div className="footer-newsletter">
                            <h2>Newsletter</h2>
                            <form name='NewsLetter'>
                                <input name='subscribe' className="form-control" placeholder="Email goes here" autoComplete='email' required/>
                                <button className="btn btn-custom">Submit</button>
                                <h6>Don't worry, we don't spam!</h6>
                            </form>
                        </div> */}
          </div>
        </div>
      </div>
      <div className="container copyright">
        <div className="row">
          <div className="col-md-6">
            <p>
              &copy; <a href="#">Al Qaim Welfare Foundation</a> | 2024, All
              Rights Reserved.
            </p>
          </div>
          <div className="col-md-6">
            <p>Designed with ❤️</p>
          </div>
        </div>
      </div>
    </div>
  );
}
